import { ErrorPage } from 'src/components';
import { useTranslation } from 'react-i18next';

const Error404 = () => {
  const { t } = useTranslation('misc');

  return (
    <ErrorPage
      code={404}
      title={t('404.title')}
      description={t('404.description')}
    />
  );
};

export { Error404 };
